(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('role', {
            parent: 'application',
            url: '/role?role_id',
            params: {
                role_id: null
            },
            data: {
                authorities: ['ROLE_RESOURCE'],
                pageTitle: 'Edycja roli - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/role/role.html',
                    controller: 'RoleController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
